export const tagsTypeArray = [
  'zinkerzCamp',
  'accomodations',
  'paidReferrer',
  'clientReferral'
  // acá vas agregando más tipos
]
